import { createSlice } from "@reduxjs/toolkit";
import Api from "../api/Api";

type State = {
  data: Array<Object>;
  daysDifference: Number;
  authors: Array<Object>;
  isLoading: boolean;
  error: Object | null;
  isLoadingAuthors: boolean,
  testAuthors: Array<Object>
};

const INITIAL_STATE = {
  data: [],
  daysDifference: 0,
  authors: [],
  isLoading: true,
  error: null,

  isLoadingAuthors: true,
  testAuthors: []
};

const abTests = createSlice({
  name: "abTests",
  initialState: INITIAL_STATE,
  reducers: {
    fetchTestArchiveStart: (state: State) => {
      state.isLoading = true;
    },
    fetchTestArchiveSuccess: (state: State, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    setDaysDifference: (state: State, action) => {
      state.daysDifference = action.payload
    },
    
    fetchTestArchiveFailed: (state: State, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.payload;
    },

    extractAuthorsSuccess: (state: State, action) => {
      state.authors = action.payload;
    },

    toggleTestDisabledStart: (state: State) => {
      state.isLoading = true;
    },
    toggleTestDisabledSuccess: (state: State, action) => {
      state.isLoading = false;
      //@ts-ignore
      const testData = state.data.results.find(test => test.id === action.payload.id);
      testData.disabled = action.payload.disabled;
    },
    toggleTestDisabledFailed: (state: State, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchTestArchiveAuthorsStart: (state: State) => {
      state.isLoadingAuthors = true;
    },
    fetchTestArchiveAuthorsSuccess: (state: State, action) => {
      state.isLoadingAuthors = false;
      state.testAuthors = action.payload;
    },
    fetchTestArchiveAuthorsFailed: (state: State, action) => {
      state.isLoadingAuthors = false;
      state.error = action.payload;
    },
 
  },
});

export default abTests.reducer;

const { 
  fetchTestArchiveStart, 
  fetchTestArchiveSuccess, 
  setDaysDifference,
  fetchTestArchiveFailed,
  extractAuthorsSuccess,
  toggleTestDisabledStart,
  toggleTestDisabledSuccess,
  toggleTestDisabledFailed,
  fetchTestArchiveAuthorsStart,
  fetchTestArchiveAuthorsSuccess,
  fetchTestArchiveAuthorsFailed
} = abTests.actions;

let currentAbTestsRequest = null;

const getAuthors = (result : any) => {
  const authors = [] as any;
  result.forEach((res : any)=>{
    if (authors.indexOf(res.createdBy.name) === -1) {
      authors.push(res.createdBy.name)
    } 
  })
  return authors.map(e => { return {label: e, value: e} })
}

const getDaysDifference = (dateFrom, dateTo) => {
  const from = new Date(`${dateFrom}T00:00:00Z`);
  const to = new Date(`${dateTo}T00:00:00Z`);

  // @ts-ignore
  const diffMs = to - from;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24)); 
}


export const fetchTestArchive = (
    dateFrom, dateTo, sections, paidStatus, type, authorsList,
    searchTerm, page, limit, 
  ) => async (dispatch: Function) => {

  try {
    if (currentAbTestsRequest) {
        // @ts-ignore;
        currentAbTestsRequest.abort()
    }
    dispatch(fetchTestArchiveStart());

    const controller = new AbortController(); // Create a new AbortController
    // @ts-ignore
    currentAbTestsRequest = controller;

    const api = new Api();


    const result = await api.getTestArchive({
            date_from : dateFrom,
            date_to: dateTo,
            sections: sections,
            search: searchTerm,
            page: page,
            limit: limit,
            paid_status: paidStatus,
            type: type,
            authors : authorsList
    });
    const authors = getAuthors(result.results);
    const daysDifference = getDaysDifference(dateFrom, dateTo);
    dispatch(extractAuthorsSuccess(authors))
    dispatch(fetchTestArchiveSuccess(result));
    dispatch(setDaysDifference(daysDifference))
  } catch (err) {
    dispatch(fetchTestArchiveFailed(err));
  }
};

export const fetchTestArchiveCSV = (
   dateFrom, dateTo, sections, paidStatus, type, authorsList,
    searchTerm, page, limit, 
) => async (dispatch: Function) => {
   try {
    const controller = new AbortController(); // Create a new AbortController
    // @ts-ignore
    currentAbTestsRequest = controller;

    const api = new Api();


    const result = await api.getTestArchive({
            date_from : dateFrom,
            date_to: dateTo,
            sections: sections,
            search: searchTerm,
            page: page,
            limit: 10000,
            paid_status: paidStatus,
            type: type,
            authors : authorsList,
            response_type: "csv"
    });

     const blob = new Blob([result], { type: 'text/csv;charset=utf-8;' });
      // 3. Create a temporary local URL for the Blob
      const url = window.URL.createObjectURL(blob);

      // 4. Create a hidden <a> anchor tag to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.csv'); // Set file name

      // 5. Append link, programmatically click it, and clean up
      document.body.appendChild(link);
      link.click();
      // @ts-ignore
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url); // Free up browser memory

  } catch (err) {
    dispatch(fetchTestArchiveFailed(err));
  }
}

const sortAuthors  = (a,b) => {
  if (a.name < b.name)
     return -1;
  if (a.name > b.name)
    return 1;
  return 0;
}

export const fetchTestArchiveAuthors = () => async (dispatch: Function) => {
  try {
    dispatch(fetchTestArchiveAuthorsStart())
    const api = new Api();
    const result = await api.getTestArchiveAuthors();
    dispatch(fetchTestArchiveAuthorsSuccess(result.sort(sortAuthors)));
  } catch (err) {
    dispatch(fetchTestArchiveAuthorsFailed(err))
  }
}

export const toggleTestDisabled = (id) => async (dispatch: Function) => {
  try {
    dispatch(toggleTestDisabledStart());
    const api = new Api();
    const result = await api.postTestDisabled(id);
    dispatch(toggleTestDisabledSuccess({id, disabled: result.disabled}));
  } catch (err) {
    dispatch(toggleTestDisabledFailed(err));
  }
};
